import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "drawer-box" }
const _hoisted_2 = { class: "detail-box" }
const _hoisted_3 = { class: "drawer-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    width: "50%",
    class: "list-detail",
    closable: false,
    visible: _ctx.show,
    "body-style": {
      position: 'relative',
      height: '100%',
      padding: '20px 20px 72px',
    },
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_typography_title, { level: 5 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_divider),
                _renderSlot(_ctx.$slots, "default")
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btns, (bi, bk) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: bk }, [
                  (bi.show !== false)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        ghost: bi.ghost ? true : false,
                        danger: bi.danger ? true : false,
                        onClick: bi.click
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(bi.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["ghost", "danger", "onClick"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["visible", "onClose"]))
}